import type { Context } from 'react';
import { createContext } from 'react';

import type {
  AutoCashingOutHelpContextProps,
  AutoPlayHelpContextProps,
  PlacingBetsHelpContextProps,
  ShowPPBrandingHelpContextProps,
} from './mapStateToHelpContextProps';

export interface HelpContextType
  extends PlacingBetsHelpContextProps,
    AutoCashingOutHelpContextProps,
    AutoPlayHelpContextProps,
    ShowPPBrandingHelpContextProps {}

export const HelpContext = createContext<HelpContextType | null>(null) as Context<HelpContextType>;
